import { render, staticRenderFns } from "./situation-details.vue?vue&type=template&id=099c8e37&lang=pug&"
import script from "./situation-details.vue?vue&type=script&lang=js&"
export * from "./situation-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099c8e37')) {
      api.createRecord('099c8e37', component.options)
    } else {
      api.reload('099c8e37', component.options)
    }
    module.hot.accept("./situation-details.vue?vue&type=template&id=099c8e37&lang=pug&", function () {
      api.rerender('099c8e37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/situationDetails/situation-details.vue"
export default component.exports